export const POSITIVE_COLOR = "#2e7d32";
export const NEGATIVE_COLOR = "#d32f2f";
export const TRANSFER_COLOR = "#1976d2";
export const VALUE_FONT_WEIGHT = 600;
